module.exports = __webpack_public_path__ + "static/media/list.b899d036.svg";